@if (hasError) {
  <ngb-alert
    class="error-alert"
    [class]="alertClass"
    [dismissible]="dismissible"
    (closed)="hasError = false"
    type="danger"
  >
    <div
      class="error-alert__collapse-toggle"
      [class.error-alert__collapse-toggle--active]="collapsible"
      [class.g-cursor-pointer]="collapsible && errorDescription.details"
      (click)="toggleCollapse()"
      role="button"
    >
      <span class="overflow-auto">
        <strong>
          <span>{{ errorDescription.title | translate }}</span>
          <span>{{ errorDescription.message ? ': ' : '' }}</span>
        </strong>
        @if (errorDescription.message; as text) {
          <span [innerHTML]="text | portalTranslate"></span>
        }
      </span>
      @if (collapsible && errorDescription.details) {
        <i class="far fa-angle-down"></i>
      }
    </div>
    <div [ngbCollapse]="isCollapsed">
      <div class="error-alert__content">
        @if (errorDescription.details; as details) {
          <div class="error-alert__details">
            @if ($any(error).id && showId) {
              <p>
                <strong>{{ 'common.errors.errorId' | portalTranslate }}</strong>
                <br />
                <span>{{ $any(error).id }}</span>
              </p>
            }
            @if (details.message; as message) {
              <p>
                @if (details.messageIsHtml === false) {
                  <strong>
                    {{ 'alert.detail.message' | portalTranslate }}
                  </strong>
                  <br />
                  {{ message }}
                }
                @if (details.messageIsHtml) {
                  <span [innerHTML]="details.message"></span>
                }
              </p>
            }
            @if (details.exception; as exception) {
              <p>
                <strong>
                  {{ 'alert.detail.exception' | portalTranslate }}
                </strong>
                <br />
                <code>{{ exception | portalTranslate }}</code>
              </p>
            }
            @if (details.resultCode; as resultCode) {
              <p>
                <strong>
                  {{ 'alert.detail.resultCode' | portalTranslate }}
                </strong>
                <br />
                {{ resultCode | portalTranslate }}
              </p>
            }
            @if (details.violatingFields?.length > 0) {
              <div>
                <strong>
                  {{ 'alert.detail.violatingFields' | translate }}
                </strong>
                <dl class="ps-3 pt-2">
                  @for (field of details.violatingFields; track field) {
                    <dt>{{ field['name'] }}</dt>
                    <dd>
                      @for (item of field | keyvalue; track item; let last = $last) {
                        @if (item.key !== 'name') {
                          {{ item.key }}: {{ item.value }} {{ last ? '' : '|' }}
                        }
                      }
                    </dd>
                  }
                </dl>
              </div>
            }
            @if (details.hint; as hint) {
              <p>
                <strong>
                  {{ 'alert.detail.hint' | translate }}
                </strong>
                <br />
                {{ hint }}
              </p>
            }
            @if (details.details; as details) {
              <p>
                <strong>
                  {{ 'alert.detail.details' | portalTranslate }}
                </strong>
                <br />
                {{ details | portalTranslate }}
              </p>
            }
            @if ($any(error).response?.custom; as custom) {
              <div [innerHTML]="custom"></div>
            }
            @if (responseIsString) {
              <code class="text-body">
                {{ details }}
              </code>
            }
          </div>
        }
      </div>
    </div>
  </ngb-alert>
}
